/**
 * Created on 2025-08-11.
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */
import { Component } from '@angular/core';

@Component({
  selector: 'curr-privacy-policy-page',
  templateUrl: './privacy-policy-page.component.html',
  styleUrls: ['./privacy-policy-page.component.scss']
})
export class PrivacyPolicyPageComponent {}
